var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Header'),_vm._v(" "),_c('div',{attrs:{"id":"layoutSidenav"}},[_c('Sidebar'),_vm._v(" "),_c('div',{attrs:{"id":"layoutSidenav_content"}},[_c('vue-page-transition',{attrs:{"name":"fade-in-right"}},[_c('router-view')],1),_vm._v(" "),_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }